import { createSlice } from "@reduxjs/toolkit";

export const baseMapsConfigSliceReducer = createSlice({
    name: "baseMapsConfig",
    initialState: { baseMapLayer: [] },
    reducers: {
        // sets data for changing opacity of layer
        setBaseMapLayer: (state, action) => {
            let prop = action.payload.prop;
            if (typeof prop === "string") {
                prop = { Visible: false };
            }
            //Reprevent loading duplicate base map layer on site reload after logging in or out.
            if (state.baseMapLayer.find((i) => i.Id === action.payload.name)) {
                return;
            }
            switch (action.payload.name) {
                case "XYZ_BaseMap":
                    state.baseMapLayer = [
                        ...state.baseMapLayer,
                        {
                            IsBaseMap: true,
                            Id: "XYZ_BaseMap",
                            DisplayName: action.payload.DisplayName,
                            ShortName: "XYZ",
                            IncludeInLayerList: true,
                            IsExpanded: false,
                            Opacity: 1,
                            Visible: prop.Visible,
                        },
                    ];
                    break;
                case "OpenStreetMap":
                    state.baseMapLayer = [
                        ...state.baseMapLayer,
                        {
                            IsBaseMap: true,
                            Id: "OpenStreetMap",
                            DisplayName: "Open Street Map",
                            ShortName: "OSM",
                            IncludeInLayerList: true,
                            IsExpanded: false,
                            Opacity: 1,
                            Visible: prop.Visible,
                        },
                    ];
                    break;
                case "MapTiler_Steet":
                    state.baseMapLayer = [
                        ...state.baseMapLayer,
                        {
                            IsBaseMap: true,
                            Id: "MapTiler_Steet",
                            DisplayName: "Map Tiler - Street Map",
                            ShortName: "Map Tiler - Street",
                            IncludeInLayerList: true,
                            IsExpanded: false,
                            Opacity: 1,
                            Visible: prop.Visible,
                        },
                    ];
                    break;
                case "MapTiler_Basic":
                    state.baseMapLayer = [
                        ...state.baseMapLayer,
                        {
                            IsBaseMap: true,
                            Id: "MapTiler_Basic",
                            DisplayName: "Map Tiler - Basic Map",
                            ShortName: "Map Tiler - Basic",
                            IncludeInLayerList: true,
                            IsExpanded: false,
                            Opacity: 1,
                            Visible: prop.Visible,
                        },
                    ];
                    break;
                case "MapTiler_Satellite":
                    state.baseMapLayer = [
                        ...state.baseMapLayer,
                        {
                            IsBaseMap: true,
                            Id: "MapTiler_Satellite",
                            DisplayName: "Map Tiler - Satellite Map",
                            ShortName: "Map Tiler - Satellite",
                            IncludeInLayerList: true,
                            IsExpanded: false,
                            Opacity: 1,
                            Visible: prop.Visible,
                        },
                    ];
                    break;
                case "BingMaps_RoadOnDemand":
                    state.baseMapLayer = [
                        ...state.baseMapLayer,
                        {
                            IsBaseMap: true,
                            Id: "BingMaps_RoadOnDemand",
                            DisplayName: "Bing - Road Map",
                            ShortName: "Bing - Road",
                            IncludeInLayerList: true,
                            IsExpanded: false,
                            Opacity: 1,
                            Visible: prop.Visible,
                        },
                    ];
                    break;
                case "BingMaps_Aerial":
                    state.baseMapLayer = [
                        ...state.baseMapLayer,
                        {
                            IsBaseMap: true,
                            Id: "BingMaps_Aerial",
                            DisplayName: "Bing - Aerial Imagery",
                            ShortName: "Bing - Aerial",
                            IncludeInLayerList: true,
                            IsExpanded: false,
                            Opacity: 1,
                            Visible: prop.Visible,
                        },
                    ];
                    break;
                case "BingMaps_AerialWithLabels":
                    state.baseMapLayer = [
                        ...state.baseMapLayer,
                        {
                            IsBaseMap: true,
                            Id: "BingMaps_AerialWithLabels",
                            DisplayName: "Bing - Aerial With Labels",
                            ShortName: "Bing - Aerial With Labels",
                            IncludeInLayerList: true,
                            IsExpanded: false,
                            Opacity: 1,
                            Visible: prop.Visible,
                        },
                    ];
                    break;
                case "BingMaps_CanvasDark":
                    state.baseMapLayer = [
                        ...state.baseMapLayer,
                        {
                            IsBaseMap: true,
                            Id: "BingMaps_CanvasDark",
                            DisplayName: "Bing - Dark Canvas",
                            ShortName: "Bing - CanvasDark",
                            IncludeInLayerList: true,
                            IsExpanded: false,
                            Opacity: 1,
                            Visible: prop.Visible,
                        },
                    ];
                    break;
            }
        },
    },
});

export const { setBaseMapLayer } = baseMapsConfigSliceReducer.actions;
export default baseMapsConfigSliceReducer.reducer;
